

    WebFontConfig = {
      google: { families: [ 
        
          "Playfair Display:100,200,300,400,500,600,700,800,900"
        
        
      ] }
    };
    (function() {
      var wf = document.createElement('script');
      wf.src = ('https:' == document.location.protocol ? 'https' : 'http') +
        '://ajax.googleapis.com/ajax/libs/webfont/1/webfont.js';
      wf.type = 'text/javascript';
      wf.async = 'false';
      var s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(wf, s);
      document.getElementsByTagName('html')[0].className -= ' wf-loading'
    })(); 

